module.exports = {"id":"dp5_1l1q2","text":"Seeking assistance","instructions":"When experiencing a technical issue, asking for help can be beneficial.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l1q2-a1","text":"True","score":1.8},{"id":"dp5_1l1q2-a2","text":"Not sure","score":0},{"id":"dp5_1l1q2-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l1q2.json
// module id = 1282
// module chunks = 41